import {checkIfHumanPlayerPresent} from '../localMatch/replay/localRunServerRules';

/**
 * Партия целиком из ботов: живых игроков нет ни одного.
 *
 * Так собирается и режим зрителя (его переключатель помечает ботами всех), и
 * партия, где игрок сам перевел все тумблеры в «Бот» — смотреть ее он будет
 * одинаково, поэтому и настройки старта у них общие.
 *
 * Пустой состав партией из ботов не считается: экран настройки отправляет
 * пустой список для пустого поля (см. HotSeatPlayersInitPage), а это
 * редактирование поля, а не матч.
 *
 * Кого считать живым, решает checkIfHumanPlayerPresent — то же правило, по
 * которому партия из одних ботов не пишет действий в запись. Там же и разбор
 * игрока без признака isBot: он считается живым.
 *
 * @param {Array} players - состав партии со страницы настройки
 * @returns {boolean}
 */
export const checkIfAllPlayersAreBots = (players) => (
  Array.isArray(players) && players.length > 0 && !checkIfHumanPlayerPresent(players)
);
